import Loader from "../Loader/Loader";
import SomethingWentWrong from "../SomethingWentWrong/SomethingWentWrong";
import DataNotFound from "../DataNotFound/DataNotFound";

export const GENERIC_ERROR_TEXT = "Something went wrong.";

// Only surface the real backend message for "our fault" 4xx-style errors;
// network failures and 5xx are noise the user can't act on.
export const getErrorText = (error) => {
  if (!error) return GENERIC_ERROR_TEXT;
  if (typeof error === "string") return error;

  const { isNetworkError, status, message } = error;
  if (isNetworkError || (typeof status === "number" && status >= 500)) {
    return GENERIC_ERROR_TEXT;
  }

  return message || GENERIC_ERROR_TEXT;
};

/**
 * Single reusable data-state gate: loading -> error -> empty -> children.
 * `error` may be a normalized error object ({ status, message, isNetworkError }
 * from the axios interceptor), a string, or any other truthy value.
 */
const DataState = ({
  isLoading,
  error,
  isEmpty,
  loaderProps,
  errorText,
  notFoundText,
  children,
}) => {
  if (isLoading) {
    return <Loader {...loaderProps} />;
  }

  if (error) {
    return <SomethingWentWrong text={errorText || getErrorText(error)} />;
  }

  if (isEmpty) {
    return <DataNotFound text={notFoundText} />;
  }

  return children;
};

export default DataState;
